/**
 * WP Dark Mode Social Share
 * Added from 2.3.7
 */
import WPDMAlpine from "alpinejs";
import axios from "axios";

// import "./webcomponents";

(function () {

    /**
     * Main core class of the module
     */
    const SocialShareApp = {
        /**
         * States as temporary variables
         */
        state: {
            activeTab: "channels",
            search_channels: "",
            showAllChannels: false,
            channels: [],
            post_types: 2,
            showAllChannels: false,
        },

        constant: {
            tabs: [
                {
                    id: "channels",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-share-fill" viewBox="0 0 16 16">
          <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
        </svg>`,
                    title: "Social Channels",
                },
                {
                    id: "customization",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-palette" viewBox="0 0 16 16">
          <path d="M8 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm4 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM5.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
          <path d="M16 8c0 3.15-1.866 2.585-3.567 2.07C11.42 9.763 10.465 9.473 10 10c-.603.683-.475 1.819-.351 2.92C9.826 14.495 9.996 16 8 16a8 8 0 1 1 8-8zm-8 7c.611 0 .654-.171.655-.176.078-.146.124-.464.07-1.119-.014-.168-.037-.37-.061-.591-.052-.464-.112-1.005-.118-1.462-.01-.707.083-1.61.704-2.314.369-.417.845-.578 1.272-.618.404-.038.812.026 1.16.104.343.077.702.186 1.025.284l.028.008c.346.105.658.199.953.266.653.148.904.083.991.024C14.717 9.38 15 9.161 15 8a7 7 0 1 0-7 7z"/>
        </svg>`,
                    title: "Customization",
                },
                // {
                //   id: "social-meta",
                //   icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-code-slash" viewBox="0 0 16 16">
                //   <path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294l4-13zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0z"/>
                // </svg>`,
                //   title: "Social Meta",
                // },
            ],
            button_positions: {
                above: "Above",
                below: "Below",
                both: "Above & Below",
            },
            button_alignments: {
                left: "Left",
                center: "Center",
                right: "Right",
                stretch: "Stretch",
            },
            button_shapes: {
                rounded: "Rounded",
                circle: "Circle",
                rectangular: "Rectangular",
                slanted: "Slanted",
            },
            button_sizes: {
                1: "S",
                1.2: "M",
                1.4: "L",
                1.6: "XL",
            },
            button_labels: {
                channel_label: "Channel Label",
                share_count: "Share Count",
                both: "Both",
                none: "None",
            },
            devices: {
                mobile: {
                    name: "Mobile",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" class="fill-current w-4" viewBox="0 0 16 16">
          <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"/>
          <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
        </svg>`,
                },
                desktop: {
                    name: "Desktop",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" class="fill-current w-5" viewBox="0 0 16 16">
          <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
        </svg>`,
                },
            },
        },

        get isUltimate() {
            return [true, 1, '1', 'true'].includes( wp_dark_mode_social_share.is_ultimate );
        },

        get isPro() {
            return this.isUltimate
        },

        get isFree() {
            return !this.isPro;
        },

        /**
         * Set Tab
         */
        setTab(tab) {
            this.state.activeTab = tab;
            window.location.hash = tab;
        },

        /**
         * Init Tab
         */
        initTab() {
            if (window.location.hash) {
                let hash = window.location.hash.substr(1);
                if (this.constant.tabs.find((tab) => tab.id === hash)) {
                    this.setTab(hash);
                }
            }
        },

        freeChannels: ["facebook", "twitter", "pinterest", "reddit", "copy"],
        /**
         * Init Channels
         */
        initChannels() {
            let channels = wp_dark_mode_social_share.channels;
            const enabledChannels = this.isFree
                ? this.freeChannels
                : channels.map((channel) => channel.id);

            channels.map((channel) => {
                channel.class = channel.class || `_icon-${channel.id}`;
                channel.enabled = enabledChannels.includes(channel.id);
                return channel;
            });

            this.state.channels = channels || [];
        },

        /**
         * Channel getter
         */

        get channels() {
            return this.state.channels;
        },
        get filteredChannels() {
            const { search_channels } = this.state;

            if (!search_channels) {
                return !this.state.showAllChannels
                    ? this.channels.slice(0, 10)
                    : this.channels;
            }

            var channels = this.channels.filter((channel) => {
                const search_in = [ channel.name.toLowerCase(), channel.id ]

                // if tags are available, merge them
                if (channel.tags) {
                    search_in.push(...channel.tags);
                }

                return search_in.some( tag => tag.includes(search_channels.toLowerCase()) );
            });

            return !this.state.showAllChannels ? channels.slice(0, 15) : channels;
        },

        /**
         * Binding backends
         */
        options: {},

        get getOptions() {
            return this.options;
        },

        isTab(tab = "channels") {
            return this.state.activeTab === tab;
        },

        get currentTab() {
            return this.constant.tabs.find((tab) => this.isTab(tab.id));
        },

        showPromo() {
            // Plugin SDK
            // WPPOOL.Popup('wp_dark_mode').show();

            // Legacy Popup
            window.WPDarkModePromo.show();
        },

        /***
         * Enable/Disable channel
         */
        toggleChannel(channelId, enable = null) {
            const allChannels = this.state.channels;
            let enabledChannels = this.getOptions.channels;

            const channel = allChannels.find(
                (currentChannel) => currentChannel.id === channelId
            );

            /**
             * If channel is NOT active, show promo message
             */

            const channelIndex = enabledChannels.findIndex(
                (currentChannel) => currentChannel.id === channelId
            );

            if (channelIndex < 0) {
                if (!channel.enabled) {
                    this.showPromo();
                    return;
                }

                enabledChannels.push({
                    id: channel.id,
                    name: channel.name,
                    visibility: {
                        desktop: true,
                        mobile: true,
                    },
                });
            } else {
                enabledChannels.splice(channelIndex, 1);
            }

            this.options.channels = enabledChannels;
        },

        get enabledChannels() {
            return this.options.channels || [];
        },

        /**
         * Is channel enabled
         */
        isChannelEnabled(channel) {
            return this.enabledChannels.find(
                (currentChannel) => currentChannel.id === channel
            );
        },

        get enabledChannelsForPreview() {
            return this.enabledChannels.slice(
                0,
                this.options.channel_visibility || 2
            );
        },

        getIcon(channelId) {
            const channel = this.channels.find(
                (currentChannel) => currentChannel.id === channelId
            );
            return channel.svg || channel.icon;
        },

        /**
         * draggingChannel
         */

        handleDrag(event, channelId) {
            let channels = this.options.channels;
            let draggingChannel = this.state.draggingChannel;

            let draggingChannelIndex = channels.findIndex(
                (currentChannel) => currentChannel.id === draggingChannel
            );
            let targetChannelIndex = channels.findIndex(
                (currentChannel) => currentChannel.id === channelId
            );
            let temp = channels[draggingChannelIndex];
            channels[draggingChannelIndex] = channels[targetChannelIndex];
            channels[targetChannelIndex] = temp;

            this.options.channels = channels;
        },
        handleDrop(event, channelId) {
            this.state.draggingChannel = null;
        },

        /**
         * Init Options
         */
        async initOptions() {
            const optionKeys = Object.keys(wp_dark_mode_social_share.options);

            const optionValues = Object.values(wp_dark_mode_social_share.options).map(
                (value) => {
                    if (value === "1") return true;
                    if (value === "0") return false;

                    if (typeof value === "object") {
                        if ("mobile" in value) {
                            value.mobile === "1";
                        }

                        if ("desktop" in value) {
                            value.desktop === "1";
                        }

                        return value;
                    }

                    return value;
                }
            );

            const options = {};

            optionKeys.forEach((key, index) => {
                let value = optionValues[index];
                options[key] = value;
            });
            //   Log(options);

            if (this.isFree) {
                options.channels = options.channels.filter((channel) =>
                    this.freeChannels.includes(channel.id)
                );

                options.button_template = 1;

                options.hide_button_on.mobile = false;
                options.hide_button_on.desktop = false;

                const freePostTypes = ["post", "page"];

                options.post_types = options.post_types.filter((postType) =>
                    freePostTypes.includes(postType)
                );

                options.button_spacing = true;
                options.show_total_share_count = false;
            }
            // not ultimate
            if (!this.isPro) {
                options.minimum_share_count = 0;
                options.maximum_click_count = 30;
                options.channel_visibility = 3;
            }

            this.state.noWatch = true;
            this.options = options;
            this.state.savedOptions = options;

            await this.saveOptions(options, true);
            this.state.noWatch = false;
        },

        /**
         * Init Post Types
         */
        initPostTypes() {
            this.constant.post_types = Object.values(
                wp_dark_mode_social_share.post_types
            ).filter((postType) => {
                return postType.id !== "attachment";
            });
        },

        init() {
            /**
             * Init Options
             */
            this.initOptions();

            /**
             * Bind events
             */
            this.bindEvents();

            /**
             * initTab
             */
            this.initTab();

            /**
             * initChannels
             */
            this.initChannels();

            /**
             * Init post types
             */
            this.initPostTypes();

            /**
             * Add options
             */

            /**
             * Watch for changes
             */
            this.$watch("options", this.onOptionsChange.bind(this));
            /**
             * Hide skeleton loader
             */

            setTimeout(() => {
                const loader = jQuery("#wpdm-social-share-loader");
                loader.fadeOut(500)
            }, 1200);
        },

        /**
         *  On Option Change
         */

        onOptionsChange(value, oldValue) {
            if (this.state.noWatch === true) {
                this.state.isChanged = false;
            } else {
                this.state.isChanged = true;
            }
        },

        /**
         * Is changed options
         */
        get isChanged() {
            return this.state.isChanged;
        },

        /**
         * Update preview
         */

        updatePreview() {
            document.documentElement.style.setProperty(
                "--wp-dark-mode-social-share-scale",
                this.options.button_size
            );
        },

        /**
         * setPostTypes
         */
        togglePostType(postType) {
            if (this.options.post_types.includes(postType)) {
                this.options.post_types = this.options.post_types.filter(
                    (currentPostType) => currentPostType !== postType
                );
            } else {
                this.options.post_types.push(postType);
            }
        },

        // toggleArchive(archive) {
        //   if (this.options.archives.includes(archive)) {
        //     this.options.archives = this.options.archives.filter(
        //       (currentArchive) => currentArchive !== archive
        //     );
        //   } else {
        //     this.options.archives.push(archive);
        //   }
        // },

        /**
         * Upload image
         */
        // openFileUploader() {
        //   const fileUploader = wp
        //     .media({
        //       title: "Select Image",
        //       button: {
        //         text: "Select Image",
        //       },
        //       multiple: false,
        //     })
        //     .open();

        //   fileUploader.on("select", () => {
        //     const attachment = fileUploader
        //       .state()
        //       .get("selection")
        //       .first()
        //       .toJSON();
        //     this.options.default_share_image = attachment.url;
        //   });
        // },

        async toggleSocialShare() {
            if (this.options.saved === true) {
                this.state.isChanged = false;
                const savedOptions = JSON.parse(
                    JSON.stringify(this.state.savedOptions)
                );
                savedOptions.enable = Boolean(this.options.enable);

                this.state.noWatch = true;
                this.options = JSON.parse(JSON.stringify(savedOptions));
                this.state.noWatch = false;
                this.state.savedOptions = savedOptions;
                this.state.isChanged = false;
                this.saveOptions(savedOptions);
                this.state.isChanged = false;
            } else {
                this.options.saved = true;
                this.state.isChanged = true;
                this.state.noWatch = false;
            }
        },

        async saveOptionsButton() {
            const options = JSON.parse(JSON.stringify(this.getOptions));
            await this.saveOptions(options);
        },

        /**
         * Save Options
         */
        async saveOptions(options = null, silence = false) {
            this.state.isChanged = false;

            if (options === null) {
                options = JSON.parse(JSON.stringify(this.getOptions));
            }

            // Saved
            if ( ! silence ) {
                clearTimeout(this.state.savedTimer);
                this.state.saved = true;

                this.state.savedTimer = setTimeout(() => {
                    this.state.saved = false;
                }, 2500);
            }

            this.state.isChanged = false;
            const response = await axios.post(
                wp_dark_mode_social_share.url?.ajax + "?action=wpdm_social_share_save_options",
                {
                    options: options,
                    nonce: wp_dark_mode_social_share.nonce,
                }
            );

            const data = response.data;
            // Log(data);

            if (data.success) {
                this.state.savedOptions = data.data;
                this.state.isChanged = false;
            }
        },

        bindEvents() {
            const Tooltips = document.querySelectorAll(".wpdarkmode-tooltip");
            if (Tooltips.length > 0) {
                Tooltips.forEach(function (tooltip) {
                    /**
                     * Add icon
                     */
                    const svg = `<svg xmlns="http://www.w3.org/2000/svg" class="_icon-svg" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/></svg>`;
                    const Icon = document.createElement("span");
                    Icon.classList.add("_icon-tooltip");
                    Icon.innerHTML = svg;

                    // inject icon

                    tooltip.appendChild(Icon);

                    // Mouse events
                    tooltip.addEventListener(
                        "mouseenter",
                        function () {
                            const title =
                                this.getAttribute("title") || this.getAttribute("data-title");
                            this.setAttribute("data-title", title);
                            this.setAttribute("title", "");
                            const TooltipContent =
                                this.querySelector(".wpdarkmode-tooltip-content") ||
                                document.createElement("div");
                            TooltipContent.classList.add("wpdarkmode-tooltip-content");
                            TooltipContent.innerHTML = title;
                            TooltipContent.style.display = "nonde";
                            this.appendChild(TooltipContent);
                            jQuery(TooltipContent).fadeIn();
                        }.bind(tooltip)
                    );

                    tooltip.addEventListener(
                        "mouseleave",
                        function () {
                            const TooltipContent = this.querySelector(
                                ".wpdarkmode-tooltip-content"
                            );
                            if (TooltipContent) {
                                jQuery(TooltipContent).fadeOut();
                                this.removeChild(TooltipContent);
                            }
                        }.bind(tooltip)
                    );

                    const badges = document.querySelectorAll(
                        ".badge-pro, .badge-ultimate"
                    );
                    if (badges && badges.length > 0) {
                        badges.forEach((badge) => {
                            badge.addEventListener("click", () => {
                                SocialShareApp.showPromo();
                            });
                        });
                    }
                });
            }
        },

        Nothing() {
            return true;
        },
        randomNumber(from = 10, to = 100) {
            return Math.floor(Math.random() * (to - from + 1) + from);
        },

        // editableChannel
        editableChannel(event) {
            const previousDiv = event.target.previousElementSibling;

            if (previousDiv) {
                previousDiv.focus();
            }

        }
    };

    // document.addEventListener("DOMContentLoaded", function () {
    WPDMAlpine.data("SocialShare", () => SocialShareApp);

    // init WPDMAlpine
    window.WPDMAlpine = WPDMAlpine;

    // init WPDMAlpine
    WPDMAlpine.start();


})(jQuery);